export enum ChartType {
    Pie,
    StackedBar,
    Bar,
    Spiderweb,
    Column,
    Line,
    Spline
}
